import { useLocalSearchParams } from 'expo-router'

import { Protected } from '@/src/features/auth/ui/components/Protected/Protected'
import { WatchmanRewardScreen } from '@/src/features/watchman/ui/screens/WatchmanRewardScreen'

export default () => {
  const searchParams = useLocalSearchParams()
  return (
    <Protected searchParams={searchParams}>
      <WatchmanRewardScreen searchParams={searchParams} />
    </Protected>
  )
}
